import { render, staticRenderFns } from "./NewPasswordPage.vue?vue&type=template&id=8c707538&scoped=true&"
import script from "./NewPasswordPage.vue?vue&type=script&lang=ts&"
export * from "./NewPasswordPage.vue?vue&type=script&lang=ts&"
import style0 from "./NewPasswordPage.vue?vue&type=style&index=0&id=8c707538&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c707538",
  null
  
)

export default component.exports